export const generateTransactionId = () => {
  const randomNumbers = Math.floor(Math.random() * 1e16);
  return `MT${randomNumbers}`;
};

export const generateMerchantUserId = (id) => {
  return `MUID${id}`;
};
